import { getTolgee } from './tolgeeInstance';

/**
 * Returns the plain text of a translation, with any in-context editor
 * decoration removed.
 *
 * When Tolgee's in-context editor is active it encodes the key into every
 * string `t()` returns — by default as a run of zero-width non-joiners and
 * joiners appended to the text (see https://docs.tolgee.io/js-sdk/wrapping).
 * The string renders identically but no longer compares equal to the text a
 * user reads off the screen and types back, so a type-the-word-to-confirm gate
 * can never be satisfied.
 *
 * `tolgee.unwrap()` is Tolgee's supported way to reverse this. Delegating to it
 * rather than matching the encoding ourselves means we stay correct if the
 * encoding changes, and if the observer is ever switched to `text` — its
 * decoration is a different format entirely, which a zero-width regex would
 * silently miss.
 *
 * Safe everywhere: with no observer running (production ships no Tolgee API
 * key) `unwrap` returns the text untouched, and before i18n has initialised
 * there is no instance to ask.
 */
export const stripTranslationMarkers = (value: string): string =>
	getTolgee()?.unwrap(value).text ?? value;
